export enum ServiceErrorType {
  ServiceUnknown = 'ERROR_SERVICE_UNKNOWN',
  MethodUnknown = 'ERROR_SERVICE_METHOD_UNKNOWN',
}
